import React, { useMemo, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useCollect } from 'hooks';

import { TASK_TYPES } from 'utils/Constants';

import Show from 'components/Show';
import Editor from 'components/Editor';
import Container from 'components/Misc/Container';
import { Title } from 'components/Misc/Typography';
import { Input, Type } from 'components/Misc/Form';

import Task from 'containers/Shared/Tasks/Task';

import { useTaskCreateStore } from 'store/task/useTaskCreateStore';

const Edit = ({ setTab }) => {
	// Store exam's id
	const { taskId } = useParams();
	
	// Update selected tab
	useEffect(() => setTab(null), [setTab]);
	
	// Use task's create store
	const [task, onInit, onReset] = useTaskCreateStore(state => [
		state.task,
		state.onInit,
		state.onReset
	]);

	// Create request parameters
	const parameters = useMemo(() => ({
		eager: 'questions.options'
	}), []);

	// Create request with parameters
	const [[result], collect] = useCollect(`tasks/${taskId}`, parameters);

	useEffect(() => {
		// Collect task if id recieved
		if (taskId) (async () => await collect())();
	}, [collect]);

	useEffect(() => {
		// Initialize task's data after collection
		if (result) onInit(result);
	}, [result]);

	useEffect(() => {
		// Reset exam's data on unmount
		return () => onReset();
	}, []);

	// TODO: Remove after testing
	useEffect(() => console.log('TASK.VIEW:', taskId, task), [taskId, task]);

	return (
		<>
			<Container
				className="mt-4 p-4 grid grid-cols-2 gap-4"
			>
				<Title
					title="Pamatinformācija"
					className="col-span-2 text-xl"
				/>

				<Input
					readOnly
					type="number"
					name="points"
					label="Punkti par pareizu atbildi"
					value={task.points}
				/>

				<Input
					readOnly
					type="number"
					name="sample"
					label="Jautājumu skaits"
					value={task.sample}
				/>

				<Title
					title="Tips"
					className="col-span-2 text-xl"
				/>

				<Type
					readOnly
					name="type"
					value={task.type}
					options={TASK_TYPES}
					className="col-span-2"
				/>

				<Title
					title="Uzdevuma apraksts"
					className="col-span-2 text-xl"
				/>

				<div className="col-span-2">
					<Editor
						readOnly
						type="description"
						name="description"
						path="exams"
						value={task.description}
					/>
				</div>

				{/* Task's questions */}
				<Show if={task.questions?.length}>
					<Title
						title="Jautājumi"
						className="col-span-2 text-xl"
					/>

					<div className="col-span-2">
						<Task />
					</div>
				</Show>
			</Container>
		</>
	);
};

export default Edit;
